import { z } from "zod";

export enum RequestFormView {
    FORM = 1,
    SIGNATURE_METHOD_SELECTION = 2,
    MAGIC_LINK = 3,
    UPLOAD_ID_CARD = 4,
    SUBMIT_SUCCESS = 5,
}

export const RequestFormViewSchema = z.nativeEnum(RequestFormView);

